exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table tr th {\r\n  text-align: center;\r\n}\r\n\r\n.table>tbody>tr>td {\r\n  border-top: 1px solid #fff;\r\n}\r\n\r\n#content {\r\n  padding: 50px;\r\n  border-top: 1px solid #fff;\r\n}\r\n\r\n.table-bordered tr,\r\n.table-bordered td,\r\n.table-bordered th {\r\n  border: 1px solid red !important;\r\n  vertical-align: middle;\r\n}\r\n\r\n.table-bordered>tbody>tr>td {\r\n  vertical-align: middle;\r\n}\r\n\r\ntable tr td {\r\n  width: 150px;\r\n}\r\n\r\ntable tr th {\r\n  text-align: center;\r\n}\r\n\r\n.table>tbody>tr>td {\r\n  border-top: none;\r\n}\r\n\r\n#content {\r\n  padding: 50px;\r\n  border-top: none;\r\n}\r\n\r\ntable {\r\n  border-collapse: collapse;\r\n}\r\n\r\n.table-bordered tr,\r\n.table-bordered td,\r\n.table-bordered th {\r\n  border: 1px solid red !important;\r\n  vertical-align: middle;\r\n}\r\n\r\n.table-bordered>tbody>tr>td {\r\n  vertical-align: middle;\r\n}\r\n\r\n.input-sm {\r\n  height: 25px;\r\n}\r\n\r\n.table>tbody>tr>td {\r\n  padding: 2px 8px;\r\n}\r\n\r\n.input-sm1 {\r\n  width: 80px !important;\r\n  padding: 0px 10px;\r\n  height: 25px;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/tejashree/src/app/edithotel/edithotel.component.css
// module id = ../../../../../src/app/edithotel/edithotel.component.css
// module chunks = main